import React from 'react'
import PropTypes from 'prop-types'
import BrandedDocument from '../../common/BrandedDocument'
import DaiTooltip from '../../common/DaiTooltip'
import Markup from '../../../../../components/atoms/Markup'

function CatalogListItem ({ catalogDatasourceId, displayName, description }) {
  return (
    <div>
      <DaiTooltip
        title={(
          <Markup type='markdown' value={description || 'This data source has not been described'} />
        )}
      >
        <div>
          <BrandedDocument
            name={displayName}
            imageUrl='https://web-ui-resources-dev.s3.us-west-2.amazonaws.com/shared/database_table.webp'
          />
        </div>
      </DaiTooltip>
    </div>
  )
}

CatalogListItem.propTypes = {
  catalogDatasourceId: PropTypes.number,
  displayName: PropTypes.string,
  description: PropTypes.string
}

export default CatalogListItem
